import { useQuery } from "@tanstack/react-query";

import { OnfleetTask } from "@web-app/types";
import http from "@web-app/utils/http";

export const useOnfleet = (entity: string, id: string) => {
  const get = async () => {
    return http
      .get<OnfleetTask[]>(`/integrations/onfleet/${entity}/${id}/tasks`)
      .then((response) => response.data)
      .catch(() => {
        return null;
      });
  };

  const { data, refetch, isLoading, isRefetching } = useQuery({
    queryFn: get,
    queryKey: ["onfleet-get-tasks", entity, id],
  });

  return {
    data,
    isLoading,
    isRefetching,
    refetch,
  };
};
